import FlexComponent from '../FlexComponent';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import './form.css';
import moneyPlant from '../../Images/money_plant_icon-img.png';
import selectedMoneyPlant from '../../Images/selected_money_plant_img.png';
import { Divider } from 'primereact/divider';

function OtherIncome({ values, errors, touched, handleBlur, handleChange, setFieldValue }) {
    const incomeSources = [
        "Investment Income",
        "Rental Income",
        "Side Job Income",
        "Child Support",
        "Alimony Income",
    ];

    const handleIncomeSourceToggle = (income) => {
        const currentIncomes = values.other_source_of_incomes || [];
        const isSelected = currentIncomes.some((item) => item.source === income);

        if (isSelected) {
            // Remove the income source
            const updatedIncomes = currentIncomes.filter((item) => item.source !== income);
            setFieldValue('other_source_of_incomes', updatedIncomes);
        } else {
            // Add the income source with default values
            const updatedIncomes = [
                ...currentIncomes,
                { source: income, monthly_or_yearly: '', amount: '' },
            ];
            setFieldValue('other_source_of_incomes', updatedIncomes);
        }
    };

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id="otherIncome">
            <div>
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', fontFamily: "Barlow Semi Condensed" }}>
                    Do you have any other sources of income?
                </p>
            </div>

            <FlexComponent flexDirection="column" gap="1rem" alignItems="start" style={{ width: '100%' }}>
                <FlexComponent flexWrap="wrap" justifyContent="start" gap="1rem" alignItems="start" style={{ width: '100%' }}>
                    {incomeSources.map((income, index) => (
                        <div
                            key={index}
                            onClick={() => handleIncomeSourceToggle(income)}
                        >
                            <FlexComponent
                                flexDirection="column"
                                alignItems="center"
                                style={{ cursor: 'pointer', width: '80px', textAlign: 'center' }}
                            >
                                <div
                                    style={{
                                        background: values.other_source_of_incomes?.some((item) => item.source === income)
                                            ? 'rgb(216 216 216 / 67%)'
                                            : '',
                                        padding: '5px 8px',
                                        marginBottom: "5px",
                                        borderRadius: "5px"
                                    }}
                                >
                                    <img
                                        src={
                                            values.other_source_of_incomes?.some((item) => item.source === income)
                                                ? selectedMoneyPlant
                                                : moneyPlant
                                        }
                                        style={{ height: '35px', width: '25px' }}
                                        alt={income}
                                    />
                                </div>
                                <div
                                    style={{
                                        fontSize: '14px',
                                        fontWeight: values.other_source_of_incomes?.some((item) => item.source === income)
                                            ? '600'
                                            : '',
                                        lineHeight: '15px',
                                    }}
                                >
                                    {income}
                                </div>
                            </FlexComponent>
                        </div>
                    ))}
                </FlexComponent>

                {values.other_source_of_incomes?.length > 0 && (
                    <FlexComponent flexDirection="column" alignItems="start" style={{ width: '100%', marginTop: "1rem" }}>
                        {values.other_source_of_incomes.map((incomeItem, index) => (
                            <div style={{width:"100%"}} >
                            <FlexComponent
                                key={incomeItem.source}
                                className="inputFlexContainer"
                                justifyContent="start"
                                gap="1rem"
                                alignItems="center"
                                style={{ width: '100%' }}
                            >
                                <div className="inputContainerDiv" style={{ width: '15%', fontSize: '16px' }}>
                                    {incomeItem.source}
                                </div>
                                <div className="inputContainerDiv" style={{ textAlign: 'start',  width: '25%' }}>
                                    <Dropdown
                                        id={`other_source_of_incomes[${index}].monthly_or_yearly`}
                                        value={incomeItem.monthly_or_yearly}
                                        options={[
                                            { label: 'Monthly', value: 'Monthly' },
                                            { label: 'Yearly', value: 'Yearly' },
                                        ]}
                                        style={{ width: '100%' }}
                                        onChange={(e) => {
                                            handleChange({
                                                target: {
                                                    name: `other_source_of_incomes[${index}].monthly_or_yearly`,
                                                    value: e.value,
                                                },
                                            });
                                        }}
                                        showClear={incomeItem.monthly_or_yearly}
                                        onBlur={handleBlur}
                                        placeholder="Mthly/Yrly"
                                    />
                                </div>
                                <div className="inputContainerDiv" style={{ textAlign: 'start',  width: '25%' }}>
                                    <div className="p-inputgroup flex-1 login-input-div">
                                        <span className="p-inputgroup-addon" style={{ borderRight: 'none' }}>
                                            <i
                                                className="pi pi-dollar"
                                                style={{
                                                    background: '#333333',
                                                    color: 'white',
                                                    padding: '5px',
                                                    borderRadius: '30px',
                                                }}
                                            ></i>
                                        </span>
                                        <InputText
                                            type="number"
                                            value={incomeItem.amount || ''}
                                            onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: `other_source_of_incomes[${index}].amount`,
                                                        value: e.target.value,
                                                    },
                                                });
                                            }}
                                            style={{ width: '100%', borderLeft: 'none' }}
                                            placeholder="Amount"
                                            className="inputWithIcon"
                                        />
                                    </div>
                                </div>
                            </FlexComponent>
                                <Divider/>
                            </div>
                        ))}
                    </FlexComponent>
                )}
            </FlexComponent>
        </div>
    );
}

export default OtherIncome;